var filter = require('../array/virtual/filter');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.filter ? filter : own;
};